export default class AbTestStatisticsCtrl {
    constructor($scope, $rootScope, $timeout, $q, $stateParams, $window, Rest, Campaign, SweetAlert, AbTest, SideMenu, $state, $filter, ChartData, Translate, Statistics, Events, Google) {
        SideMenu.setActive('campaign');

        this._stateParams = $stateParams;
        this._window = $window;
        this._state = $state;
        this._timeout = $timeout;
        this._filter = $filter;
        this._scope = $scope;
        this._rootScope = $rootScope;
        this._q = $q;

        this.campaignRepo = Campaign;
        this.abTestRepository = AbTest;
        this.statisticRepo = Statistics;
        this.chartDataRepo = ChartData;
        this.translateRepo = Translate;
        this.eventsRepo = Events;
        this.googleRepo = Google;
        this.restRepo = Rest.rest;
        this.sweetAlert = SweetAlert;

        this.colorMap = this.chartDataRepo.getColorMap();
        this.chartOptions = this.chartDataRepo.getDefaultOptions();
        this.status = this._stateParams.folder;

        let showNumbers = this._window.localStorage.getItem('settings.statistics.showNumbers');

        this.settings = {
            showDeviceStats: false,
            currentPage: 1,
            selection: 'unique',
            bouncedSelection: 'soft',
            unsubscribedSelection: 'user',
            showNumbers: showNumbers ? showNumbers : true,
            disabledDispatchers: []
        };

        this.utms = [];

        this.statistics = [];
        this.statistics.allDisabled = false;
        this.analytics = [];
        this.profiles = this.googleRepo.profiles;
        this.totals = false;

        this.typeToTranslation = {
            open: 'STATISTIC:EXPORT:AB_TEST:OPENED_DESC',
            link: 'STATISTIC:EXPORT:AB_TEST:CLICKED_DESC',
            browser: 'STATISTIC:EXPORT:AB_TEST:IN_BROWSER_DESC',
            received: 'STATISTIC:EXPORT:AB_TEST:RECEIVED_DESC',
            unsubscribed: 'STATISTIC:EXPORT:AB_TEST:UNSUBSCRIBED_DESC',
            hard_bounce: 'STATISTIC:EXPORT:AB_TEST:HARD_BOUNCE_DESC',
            soft_bounce: 'STATISTIC:EXPORT:AB_TEST:SOFT_BOUNCE_DESC',
            spam: 'STATISTIC:EXPORT:AB_TEST:SPAM_DESC'
        };

        // Check whether an export is running or has been finished.
        this._timeout(() => {
            this.statisticRepo.exportProgress(this._stateParams.id).then((exportProgress) => {
                this.exportData = exportProgress;

                if (exportProgress && exportProgress.meta != null) {
                    this.exportActive = true;
                    this._rootScope.$emit('progress:start', 'statistic-export');
                }
            });
        }, 2000);

        this._scope.$watch('settings.selection', () => {
            if (this.initialized) {
                this.settings.showDeviceStats ? this.getDeviceStats() : this.getStatistics();
            }
        });

        this._scope.$watch('settings.showDeviceStats', () => {
            if (this.initialized) {
                this.busy = true;
                this.settings.showDeviceStats ? this.getDeviceStats() : this.getStatistics();
            }
        });

        this._scope.$watch('status', () => {
            if (this.status !== 'google') {
                this.getCounts();
                this.getStatistics();
            }

            this.settings.showDeviceStats = false;

            if (this.status === 'link') {
                this.getLinks();
            } else if (this.status === 'google') {
                this.getGoogleTab();
            }
        }, true);

        this._scope.$watch('settings.showNumbers', (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.generateCharts();
            }
        });

        this._scope.$watch(this.watchProfiles(), (profiles) => {
            this.profiles = profiles;
        });

        this._scope.$on('goals:got', (event, goals) => {
            let count = Object.keys(goals).length;
            if (count === this.utms.length) {
                let dates = moment(this.settings.startDate).format('YYYY-MM-DD') + ':' + moment(this.settings.endDate).format('YYYY-MM-DD');
                this.goals = goals;
                if (goals) {
                    this.statisticRepo.storeAbGoals(goals, this.utms, dates, this.analytics.currentProfile, this.abTest.id);
                }
            }
            this.totals = this.googleRepo.getTotals(goals);
        });

        this._scope.$watch('analytics.currentProfile', (newVal, oldVal) => {
            if (newVal !== oldVal && newVal !== 'none') {
                this.googleRepo.counter = 0;
                this.getGoogleData();
            }
        });

        var recountListener = this._rootScope.$on('statistics:abTest:recount', () => {
            this.recount();
        });

        var redrawListener = this._rootScope.$on('statistics:abTest:redraw', () => {
            this.generateCharts(); // Redraw the charts
        });

        this._scope.$on('$destroy', redrawListener);
        this._scope.$on('$destroy', recountListener);

    };

    formatStatisticType() {
        if (this.status === 'bounced') {
            return this.settings.bouncedSelection + '_bounce';
        } else if (this.status === 'unsubscribed') {
            return this.settings.unsubscribedSelection === 'user' ? 'unsubscribed' : 'spam';
        } else {
            return this.status;
        }
    };

    getStatistics() {
        var status = this.formatStatisticType();

        this.statisticRepo.getAbTestStatistics(this._stateParams.id, this.settings, status).then((results) => {
            this.statistics = results.stats;
            this.abTest = results.abTest;
            this.settings.startDate = moment(results.startDate, 'YYYY-MM-DD');
            this.settings.endDate = moment(results.endDate, 'YYYY-MM-DD');

            angular.forEach (this.statistics, (stats, index) => {
                stats.dispatcher.active = true;
                this.getUtm(stats.dispatcher.id);
                if (stats.dispatcher.id === this.abTest.winner_campaign_id) {
                    if (this.abTest.sample !== 100) {
                        this.statistics.splice(index, 1); // remove the item
                        stats.dispatcher.name = this._filter('translate')('CAMPAIGN:AB_TEST:WINNER') + ': ' + stats.dispatcher.name;
                        this.statistics.unshift(stats); // add first
                    }
                }
            });

            this.busy = false;
            this.generateCharts();

            if (! this.calendar) {
                this.initialized = true;
                this.initCalendar(this.settings.startDate, this.settings.endDate);
            }
        })
    };

    formatCounts() {
        this.uniqueCounts = [];
        this.totalCounts = [];

        angular.forEach(this.counts, (campaign) => {

            _.map(campaign.counts, (count) => {
                if (! this.uniqueCounts[count.type] || ! this.totalCounts[count.type]) {
                    this.uniqueCounts[count.type] = 0;
                    this.totalCounts[count.type] = 0;
                }

                this.uniqueCounts[count.type] += count.uniqueCount;
                this.totalCounts[count.type] += count.totalCount;
            });
        });
    };

    getDeviceStats() {
        var status = this.formatStatisticType();

        this.statisticRepo.abTestDeviceStats(this._stateParams.id, status, this.settings).then((response) => {
            this.devices = this.restRepo.stripRestangular(response);
            this.generateCharts();
            this.busy = false;
        });
    };

    setPeriod(startDate, endDate) {
        if (startDate !== this.settings.startDate || endDate !== this.settings.endDate) {
            this.settings.startDate = startDate;
            this.settings.endDate = endDate;

            if (this.status != 'google') {
                this.getStatistics();
            } else if (this.analytics.currentProfile) {
                this.getGoogleData();
            }

            this.getCounts();
            this.getLinks();
            this._scope.$broadcast('recounted');
        }
    };

    initCalendar(startDate, endDate) {
        var earliestDate = new Date();
        earliestDate.setYear(earliestDate.getYear() - 1); // Max one year back.
        this.calendar = new Calendar({
            element: $('.daterange--double'),
            earliest_date: earliestDate,
            latest_date: moment(),
            start_date: startDate,
            end_date: endDate,
            same_day_range: true,
            days_array: ['Mo','Tu','We','Th','Fr','Sa','Su'],
            callback: () => {
                this.setPeriod(moment(this.calendar.start_date), moment(this.calendar.end_date));
            }
        });
    };

    generateCharts() {
        this.chartDataRepo.clear();

        angular.forEach(this.statistics, (campaignStats, index) => {
            var colorIdx = campaignStats.dispatcher.id === this.abTest.winner_campaign_id ? 'main' : index;
            var dataPoints = [];

            if (! this.settings.showNumbers) { // Show percentage
                this.chartOptions.scaleLabel = '<%= Number(value) + " %" %>';

                angular.forEach(campaignStats.data, (dateCount) => {
                    var percentageOfSent = ((dateCount.count / campaignStats.dispatcher.total_sent) * 100).toFixed(1);
                    dataPoints.push({ count: percentageOfSent, created_at: dateCount.created_at });
                });
            } else {
                this.chartOptions.scaleLabel = '<%= Number(value) %>';
                dataPoints = campaignStats.data;
            }

            this.chartData = this.chartDataRepo.addStatisticsData(
                campaignStats.dispatcher.name,
                dataPoints,
                this.settings,
                this.colorMap[colorIdx],
                ! campaignStats.dispatcher.active,
                ! this.settings.showNumbers
            );
        });

        this.devicesData = this.chartDataRepo.deviceStatisticsData(
            this.devices,
            this.settings.startDate,
            this.settings.endDate
        );
    };

    getLinks() {
        this.statisticRepo.getLinksByAbTest(this._stateParams.id, this.settings).then((response) => {
            this.links = response;
        });
    };

    percentage(number, totalSent) {
        if (! number || ! totalSent || totalSent === 0 || number === 0) {
            return 0;
        }

        return (parseFloat(number / totalSent) * 100).toFixed(1) || 0;
    };



    hasStatistics() {
        if (this.status == 'google') {
            return false;
        }
        if (this.totalCounts) {
            var type = this.formatStatisticType();
            return this.totalCounts[type] > 0;
        }
    };

    getCounts() {
        this.statisticRepo.getAbStatusCounts(this._stateParams.id, this.settings).then((response) => {
            this.counts = response.stats;
            this.formatCounts();
        });
    };

    recount() {
        this.uniqueCounts = [];
        this.totalCounts = [];
        this.settings.disabledDispatchers = [];
        this.statistics.allDisabled = true;

        angular.forEach(this.counts, (campaign) => {
            angular.forEach (this.statistics, (stats) => {
                if (stats.dispatcher.id === campaign.dispatcher.id) {
                    if (stats.dispatcher.active) {
                        _.map(campaign.counts, (count) => {
                            if (! this.uniqueCounts[count.type] || ! this.totalCounts[count.type]) {
                                this.uniqueCounts[count.type] = 0;
                                this.totalCounts[count.type] = 0;
                            }
                            this.uniqueCounts[count.type] += count.uniqueCount;
                            this.totalCounts[count.type] += count.totalCount;
                        });
                        this.statistics.allDisabled = false;
                    }
                }
            });
        });
        this.enableDispatchers();
        this._scope.$broadcast('recounted');
    };

    enableDispatchers() {
        angular.forEach(this.statistics, (stat) => {
            if (!stat.dispatcher.active){
                this.settings.disabledDispatchers.push(stat.dispatcher.id);
            }
        });
        this.getLinks();
    };

    toggleChartAxis() {
        this.settings.showNumbers = ! this.settings.showNumbers;
        this._window.localStorage.setItem('settings.statistics.showNumbers', this.settings.showNumbers);
    };



    setStatus(status) {
        this._state.go(this._state.current.name, {id: this._stateParams.id, folder: status });
    };

    //google part
    goToGoogleTab() {
        if (this.utms.length != 0) {
            this.setStatus('google');
        } else {
            this.eventsRepo.flashEvent('error', this._filter('translate')('STATISTIC:GOOGLE:NO_UTM'));
        }
    };

    getGoogleTab() {
        if (! this.currentUser) {
            this.googleRepo.auth();
        }

        if (this.analytics.currentProfile) {
            this.getGoogleData();
        }
    };

    hasCached() {
        var dates = moment(this.settings.startDate).format('YYYY-MM-DD') + ':' + moment(this.settings.endDate).format('YYYY-MM-DD');
        var defer = this._q.defer();
        this.cached = false;

        this.statisticRepo.getCachedAbGoal(this.utms, dates, this.analytics.currentProfile, this.abTest.id).then((goals) => {
            this.cached = goals.goals;
            defer.resolve(goals.goals);
        });

        return defer.promise;
    };

    getGoogleData() {
        this.googleRepo.setUtms(this.utms);
        this.googleRepo.setDates(this.calendar.start_date, this.calendar.end_date);
        this.hasCached().then((result) => {
            if (result) {
                this.goals = result;
                this.totals = this.googleRepo.getTotals(this.goals);
            } else {
                for (var i = 0; i < this.utms.length; i++) {
                    this.googleRepo.getGoogleData(this.analytics.currentProfile, this.utms[i]);
                }
            }
        });
    };

    watchProfiles() {
        return this.googleRepo.getProfiles();
    };

    getUtm(dispatcher_id) {
        if (this.dispatcherType === 'automation') {
            this.statisticRepo.getEmailUtm(dispatcher_id).then((result) => {
                if (result.utm) {
                    this.utms.push(result.utm);
                }
            });
        } else {
            this.statisticRepo.getCampaignUtm(dispatcher_id).then((result) => {
                if (result.utm) {
                    this.utms.push(result.utm);
                }
            });
        }
    };

    printExportMetaData() {
        var prefix = this.exportData.meta.hasStatistic ? 'GLOBAL:HAS' : 'STATISTIC:EXPORT:HAS_NOT';
        var type = this.typeToTranslation[this.exportData.meta.type];
        return this._filter('translate')(prefix).toLowerCase() + ' ' + this._filter('translate')(type).toLowerCase();
    };

    downloadExport() {
        this._window.open(this.exportData.url);
    };

}
